<template>
  <div class="kid-wrapper" :class="'theme-'+ (settings ? settings.theme : '1')">
    <header class="kid-header">
      <button class="btn" @click.prevent="openLoginPopup(true)">{{$lang.messages.sign_in}}</button>
    </header>
    <div class="decor-0"></div>
    <div class="decor-1"></div>
    <div class="decor-2"></div>
    <div class="decor-3"></div>
    <div class="decor-4"></div>
    <div class="decor-5"></div>
    <div class="decor-6"></div>
    <div class="decor-7"></div>
    <div class="decor-8"></div>
    <div class="decor-9"></div>
    <div class="decor-10"></div>
    <div class="kid-dialog-block">
      <div class="kid-dialog" :class="{'-fixed-height': !completeStep && !initStepStart}">
        <DecorKidDialog/>
          <div v-if="initStepStart" class="kid-dialog-content">
          <div class="kid-dialog-title mt-3 mb-3">{{$lang.messages.kid.welcome_to}}</div>
          <div class="kid-dialog-content text-center">
            <img alt="logo" src="./../assets/img/logo.svg" class="w-75">
          </div>
        </div>
        <transition name="fade">
          <div class="kid-dialog-content" v-if="initStep && settings && !initStepStart" >
            <VueSlickCarousel @beforeChange="changeSlide" ref="carousel" class="welcome-slider" :class="{'android-slide': isAndroidSlide}" :infinite="false" :touchMove=false :swipe=false :adaptiveHeight=true :arrows="true" :dots="true">
              <div class="welcome-slider-item">
                <div class="kid-dialog-title">{{$lang.messages.kid.choose_child_age}}</div>
                <div class="choose-age-block">
                  <div class="row">
                  <div class="col-6">
                    <div class="choose-age-item" :class="{active: settings.kidAge === '5-8' || settings.kidAge ===''}" @click="settings.kidAge = '5-8'; saveSettings()">
                      <div class="choose-age-item-label"><strong>5-8</strong> {{$lang.messages.years}}</div>
                      <div class="choose-age-item-img">
                        <img src="./../assets/img/kid/kid-small.svg" alt="5-8 years" width="126" height="189">
                      </div>
                      <div class="choose-age-item-text">{{$lang.messages.kid.choose_age_description1}}</div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="choose-age-item" :class="{active: settings.kidAge === '9-12'}" @click="settings.kidAge = '9-12'; saveSettings()">
                      <div class="choose-age-item-label"><strong>9-12</strong> {{$lang.messages.years}}</div>
                      <div class="choose-age-item-img">
                        <img src="./../assets/img/kid/kid-large.svg" alt="9-12 years" width="126" height="189">
                      </div>
                      <div class="choose-age-item-text">{{$lang.messages.kid.choose_age_description2}}</div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
              <div class="welcome-slider-item">
                <div class="kid-dialog-title">{{$lang.messages.kid.choose_background}}</div>
                <div class="row">
                  <div :key=theme.id v-for="theme in themes" class="col-xs-4 col-6">
                    <div class="theme-preview-wrapper" :class="{active: settings.theme === theme.id}" @click="chooseTheme(theme.id, theme.premium)">
                      <span v-if="theme.premium && !settings.isPremium" class="ribbon-premium"></span>
                      <div class="theme-preview">
                        <img :src="imgUrl(theme.src)" alt="theme preview">
                      </div>
                    </div>
                  </div>
                </div>
                <p class="text-thin">{{$lang.messages.kid.choose_background_description}}</p>
              </div>
              <div class="welcome-slider-item">
                <div class="kid-dialog-title">{{$lang.messages.kid.recommended_links_title}}</div>
                <div class="kid-recommended-list">
                  <div :key="link.id"
                       v-for="link in recommendedLinks"
                       :class="{active: checkedRecommendedLinks.includes(link.id) }"
                       class="kid-recommended-link">
                    <div class="kid-recommended-link-check" @click="toggleRecommended(link.id)"></div>
                    <div class="kid-recommended-link-content">
                      <div class="kid-recommended-link-header">
                        <div class="kid-recommended-link-info">
                          <div class="kid-recommended-link-title">
                            <span class="kid-recommended-link-icon">
                              <img :src="link.icon" :alt="link.title">
                            </span>
                            {{link.title}}
                          </div>
                          <a :href="link.url" target="_blank" class="kid-recommended-link-domain">{{link.domain}}</a>
                        </div>
                        <div class="kid-recommended-link-rating"><i v-for="index in 5" :key="index" class="icon-star" :class="{active: link.rating >= index}"></i></div>
                      </div>
                      <div class="kid-recommended-link-text">
                        {{link.desc}}
                      </div>
                    </div>
                  </div>
                </div>
                <p class="text-thin">{{$lang.messages.kid.recommended_links_description}}</p>
              </div>
              <div class="welcome-slider-item">
                <div class="kid-dialog-title">{{$lang.messages.kid.choose_lock_configuration}}</div>
                <div class="flex mb-1 flex-wrap-xs">
                  <label class="radio-wrapper -large" :class="{active: settings.unlockMethod === 'math'}">
                    <input name="unlockMethod" type="radio"  class="radio-input" value="math" :checked="settings.unlockMethod === 'math'" @change="settings.unlockMethod = $event.target.value; saveSettings()">
                    <span class="radio-check"></span>
                    <span class="radio-label -middle">{{$lang.messages.settings.unlock_method.math}}</span>
                    <span class="radio-text -absolute">{{$lang.messages.settings.unlock_method.default}}</span>
                    <span class="radio-text">{{$lang.messages.settings.unlock_method.example}}</span>
                    <span class="radio-label -large">6 x 9 = ?</span>
                    <span class="text-thin text-sm text-muted">{{$lang.messages.settings.unlock_method.math_description}}</span>
                  </label>
                  <label class="radio-wrapper -large" :class="{active: settings.unlockMethod === 'pass'}" @click="openLoginPopup">
                    <input name="unlockMethod" :disabled="!(user && user.email)"  type="radio" class="radio-input" value="pass" :checked="settings.unlockMethod === 'pass'" @change="settings.unlockMethod = $event.target.value; saveSettings()">
                    <span class="radio-check"></span>
                    <span class="radio-label -middle">{{$lang.messages.settings.unlock_method.password}}</span>
                    <InputPassword v-if="user.email" :value="settings.password" @changepassword="changeUserPassword"/>
                    <span class="flex-v-center" v-else>
                      <span class="radio-text -absolute">{{$lang.messages.need_sign_in}}</span>
                      <span class="radio-text">{{$lang.messages.settings.unlock_method.for_set_pas}}</span>
                      <a href="#" @click.prevent="showLoginModal = true" class="btn btn-outline">{{$lang.messages.sign_in}}</a>
                    </span>
                    <span class="mt-1 text-thin text-sm text-muted">{{$lang.messages.settings.unlock_method.password_description}}</span>
                  </label>
                </div>
              </div>
              <div class="welcome-slider-item" v-if="isAndroid">
                <div class="kid-dialog-permission mb-3">
                  <div class="kid-dialog-permission-title">
                    {{$lang.messages.android.permissionSlide.title}}
                  </div>
                  <div>
                    <img src="./../assets/img/kid/permission-dino.svg" width="192" height="192" alt="dino">
                  </div>
                </div>
                <div class="ask-permission-section flex align-center" @click="askOverlayPermission">
                  <div class="ask-checkbox" :class="{'checked': !disabledAllowAndroidOverlay}"></div>
                  {{$lang.messages.android.permissionSlide.label}}
                </div>
              </div>
            </VueSlickCarousel>
            <div class="text-center mt-2" v-if="isAndroidSlide">
              <button @click="showNextSlide" :disabled="disabledAllowAndroidOverlay"  class="btn btn-main android-finish-btn">
                {{$lang.messages.parent_dashboard.title}}
              </button>
            </div>
            <div class="text-right mt-2" v-else>
              <button @click="showNextSlide" :disabled="disableNextButton" class="btn btn-main">{{$lang.messages.kid.next}} <span class="btn-arrow"></span></button>
            </div>
          </div>
        </transition>
        <transition name="fade">
          <div class="kid-dialog-content" v-if="completeStep">
            <div class="flex-v-center">
              <div class="w-50">
                <div class="text-huge text-bold mr-1 mb-1">{{$lang.messages.kid.configuration_complete}}</div>
                <div class="mr-3">{{$lang.messages.kid.configuration_complete_desc}}</div>
              </div>
              <div>
                <img src="./../assets/img/kid/complete-step.svg" width="250" height="250" alt="Configuration complete">
              </div>
            </div>
            <div class="ml-3">
              <svg width="200" height="100" viewBox="0 0 200 100">
                <defs>
                  <filter id="goo">
                    <feGaussianBlur in="SourceGraphic" stdDeviation="7" result="blur" />
                    <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 17 -7" result="cm" />
                    <feComposite in="SourceGraphic" in2="cm"/>
                  </filter>
                  <filter id="f2" x="-200%" y="-40%" width="400%" height="200%">
                    <feOffset in="SourceAlpha" dx="9" dy="3" />
                    <feGaussianBlur result="blurOut" in="offOut" stdDeviation="0.51" />
                    <feComponentTransfer>
                      <feFuncA type="linear" slope="0.05" />
                    </feComponentTransfer>
                    <feMerge>
                      <feMergeNode/>
                      <feMergeNode in="SourceGraphic" />
                    </feMerge>
                  </filter>
                </defs>
                <g style="fill:#FFFFFF">
                  <ellipse id="drop" cx="50" cy="45" rx="20" ry="20" fill-opacity="1" fill="#7D6AED"/>
                  <ellipse id="drop2" cx="65" cy="45" rx="20" ry="20" fill-opacity="1" fill="#7D6AED"/>
                </g>
              </svg>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-show="showLoginModal" class="modal" @click.self="showLoginModal = false; withRedirect = false">
      <div class="modal-dialog modal-dialog-sm">
        <div id="firebaseui-auth-container"></div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
const images = require.context('../assets/img/themes/', false, /\.jpg$/)
import router from "@/router";
import DecorKidDialog from "@/components/DecorKidDialog";
import InputPassword from "../components/InputPassword";
import {db} from "@/fb/firebase";
import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import 'firebaseui/dist/firebaseui.css'
import {recommendedLinks, notAvailableForMobileDomains} from "../helpers/configs";
import {reportEvent, sendRegistrationEmail} from "@/helpers/utils";

export default {
  name: 'BaseSetting',
  data: function () {
    return {
      user: {
        uid: null,
        email: null
      },
      settings: null,
      currentWelcomeSlide: 0,
      initStep: true,
      initStepStart: true,
      completeStep: false,
      showLoginModal: false,
      withRedirect: false,
      checkedRecommendedLinks: [1,2,3,4,5],
      themes: [
        {
          id: 1,
          src: '1.jpg',
          premium: false
        },
        {
          id: 2,
          src: '2.jpg',
          premium: false
        },
        {
          id: 3,
          src: '3.jpg',
          premium: false
        },
        {
          id: 4,
          src: '4.jpg',
          premium: false
        },
      ],
      redirectTimeout: null,
      unsubscribeFB: null,
      recommendedLinks: window.Android ? recommendedLinks.filter(link => !notAvailableForMobileDomains.includes(link.url)) : recommendedLinks,
      isAndroid: window.Android,
      isAndroidSlide: false
    }
  },
  mounted () {
    setTimeout(() => this.initStepStart = false, 3000)
    this.$analytics.fbq.event('Install')
    this.$gtag.event('conversion', {
      'send_to': 'AW-311471832/0dDICPy-vPACENjdwpQB'
    })

    localStorage.setItem('extInstalledDate', Date.now().toString());
    const $this = this;
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebaseui-auth-container', {
      signInOptions: [
        {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: false,
        }
      ],
      autoUpgradeAnonymousUsers: true,
      signInFlow: 'popup',
      callbacks: {
        signInSuccessWithAuthResult(authResult) {
          $this.user.email = authResult.user.email;
          $this.showLoginModal = false;
          if (authResult.additionalUserInfo.isNewUser) {
            reportEvent('createAccount', {'email': authResult.user.email})
            $this.$analytics.fbq.event('CompleteRegistration')
            this.$gtag.event('conversion', {
              'send_to': 'AW-311471832/mQ27CImxlPACENjdwpQB'
            })
            sendRegistrationEmail(authResult.user.email)
          } else {
            reportEvent('userSignIn', {'userID': authResult.user.uid, 'isAnonymous': false, 'email': authResult.user.email})
          }
          return false;
        },

        signInFailure(error) {
          if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
            return Promise.resolve();
          }
          var cred = error.credential;
          return firebase.auth().signInWithCredential(cred).then(() => {
            $this.goToParent();
          });
        },
        uiShown() {
        }
      },
    });
  },
  created() {
    const { currentUser } = firebase.auth();
    this.updateUserInfo(currentUser);

    if (!currentUser) {
      this.unsubscribeFB = firebase.auth().onAuthStateChanged((user) => {
        this.updateUserInfo(user);
      });
    }
  },
  destroyed() {
    if (this.unsubscribeFB) {
      this.unsubscribeFB();
    }
  },
  methods: {
    updateUserInfo(user) {
      if (user) {
        this.showLoginModal = false;
        if (!user.isAnonymous) {
          this.user.email = user.email;
        }
        this.user.uid = user.uid;

        if (this.user.uid) {
          this.$rtdbBind('settings', db.ref('users/' + this.user.uid + '/settings')).then(() => {
            // cb after bind
            if (this.settings && !user.isAnonymous && !this.settings.isRegistered){
              this.savesettings({isRegistered: true})
              sendRegistrationEmail(this.user.email)
              reportEvent('createAccount', {'email': this.user.email})
              this.$analytics.fbq.event('CompleteRegistration')
              this.$gtag.event('conversion', {
                'send_to': 'AW-311471832/mQ27CImxlPACENjdwpQB'
              })
            }
            if (this.withRedirect || (this.settings && this.settings.baseSettingsDone)) {
              this.goToParent()
            }
          })
        }
      }
    },
    imgUrl: function (path) {
      return images('./' + path)
    },
    openLoginPopup(withRedirect){
      this.showLoginModal = true
      if (withRedirect) {
        this.withRedirect = true
      }
    },
    chooseTheme (id, premium) {
      if (premium && !this.settings.isPremium){
        this.showOnlyPremiumModal = true
        return false
      }
      this.settings.theme = id;
      this.saveSettings();
    },
    toggleRecommended (id) {
      if (this.checkedRecommendedLinks.includes(id)) {
        const index = this.checkedRecommendedLinks.indexOf(id);
        this.checkedRecommendedLinks.splice(index, 1);
      } else {
        this.checkedRecommendedLinks.push(id)
      }
    },
    showNextSlide () {
      if (this.currentWelcomeSlide === this.$refs.carousel.$el.querySelectorAll('.slick-slide').length - 1){ /* if last slide*/
        this.initStep = false
        this.completeStep = true
        this.redirectTimeout = setTimeout(this.goToParent, 3000);
        this.saveSettings({baseSettingsDone: true});
      } else {
        this.$refs.carousel.next()
      }
    },
    changeSlide (prevSlide, nextSlide) {
      this.currentWelcomeSlide = nextSlide
      this.getIsAndroidSlide()
    },
    goToParent () {
      if (this.redirectTimeout) {
        clearTimeout(this.redirectTimeout)
      }
      router.push('/')
      this.settings.links = this.settings.links ?
          this.settings.links.concat(recommendedLinks.filter((item) => this.checkedRecommendedLinks.includes(item.id)))
          : recommendedLinks.filter((item) => this.checkedRecommendedLinks.includes(item.id)) || [];
      this.settings.links.splice(10,this.settings.links.length - 10)
      const uniqueLinks = [];
      this.settings.links.forEach(function(item){
        const i = uniqueLinks.findIndex(x => x.id === item.id);
        if(i <= -1){
          uniqueLinks.push(item);
        }
      });
      this.settings.links = uniqueLinks;
      this.saveSettings();
    },
    saveSettings (settings = {}) {
      db.ref('users/' + this.user.uid).child('settings').set(Object.assign({}, this.settings, settings)).then(() => {
        console.log('user updated!')
      })
    },
    changeUserPassword(value) {
      this.settings.password = value

    },
    askOverlayPermission() {
      if (window.Android) {
        window.Android.sendJsMsgToWebViewForPermission('1');
      }
    },
    getIsAndroidSlide() {
      const isLastSlide = this.$refs.carousel && this.currentWelcomeSlide === this.$refs.carousel.$el.querySelectorAll('.slick-slide').length - 1;
      this.isAndroidSlide = this.isAndroid && isLastSlide
    },
  },
  computed: {
    disableNextButton() {
      const isPwordSlide = this.$refs.carousel ? this.currentWelcomeSlide === 3 : false;
      const password = this.settings ? this.settings.password : null;
      const isPwordDisable = isPwordSlide && this.settings.unlockMethod === 'pass' && !password;
      return isPwordDisable
    },
    disabledAllowAndroidOverlay() {
      if(!this.settings) {
        return true;
      }

      return !this.settings.OverLayPermission;
    }
  },
  components: {DecorKidDialog, VueSlickCarousel, InputPassword }
}
</script>

<style lang="scss">
@import "../assets/styles/themes";
@import "../assets/styles/kid";

.kid-dialog.-fixed-height {
  min-height: 520px;
  padding-bottom: 25px;
}

.welcome-slider {
  min-height: 360px;

  @include responsive-below-height('750px'){
    min-height: 300px;
  }
}

.btn-arrow {
  display: inline-block;
  margin-left: 7px;
  width: 10px;
  height: 2px;
  background: #2E2E2E;
  position: relative;
  vertical-align: 4px;

  &:before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border: solid 2px #2E2E2E;
    position: absolute;
    top: -3px;
    right: 0;
    transform: rotate(45deg);
    border-left: 0;
    border-bottom: 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}

.fade-leave-active {
  display: none;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

#drop {
  transformOrigin: '50% 50%';
  animation: slidein 1s infinite alternate ease-in-out, r 0.3s infinite alternate;
}

#drop2 {
  animation: slidein2 1s -0.5s infinite alternate ease-in-out, r1 0.5s infinite alternate;
}

@keyframes slidein {
  to {
    cx: 125;
    rx: 30;
    ry: 30;
  }
}
@keyframes slidein2 {
  to {
    cx: 110;
    rx: 10;
    ry: 10;
  }
}
@keyframes r {
  to {
    rx: 30;
    ry: 30;
  }
}
@keyframes r2 {
  to {
    rx: 10;
    ry: 10;
  }
}

</style>
